/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

function SelectTag({ banksData, label, onChange }) {
  const [selectedCityId, setSelectedCityId] = useState("");

  const handleCityChange = (event) => {
    const cityId = event.target.value;
    setSelectedCityId(cityId);
    if (onChange) {
      onChange(cityId);
    }
  };

  return (
    <FormControl sx={{ width: 180 }}>
      {/* <InputLabel>{label}</InputLabel> */}
      <Select
        displayEmpty
        sx={{ height: 33 }}
        value={selectedCityId}
        onChange={handleCityChange}
      >
        <MenuItem value="" disabled>
          {label}
        </MenuItem>
        {banksData.map((bank) => (
          <MenuItem key={bank.id} value={bank.id}>
            {bank.bankName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default SelectTag;
